export default __webpack_public_path__ + "d713b5e94ecd25b21593fef88d83e968.svg";